import { Formik } from "formik";
import * as yup from "yup";
import React, { Fragment, useState } from "react";
import MainCalculatorsList from './MainCalculators';
import SharedHelmet from '.././Helmet';
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import { Button, TextField } from "@mui/material";
const TITLE = "حساب الجذر التربيعي والتكعيبي";
const DESCRIPTION = "هذه الحاسبة المجانية للجذر تحسب الجذور للأرقام، بما في ذلك الجذور الشائعة مثل الجذر التربيعي أو الجذر التكعيبي وحساب جذر أي رقم.";
const KEYWORDS = "حاسبة، جذر، جذور، مجانية، جذر تربيعي، جذر تكعيبي، حساب جذر، أرقام";
const OG_URL = "https://do-calculate.com/calculator/ar/roots";
const rootSchema = yup.object().shape({
  xRoot1: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  xRoot2: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  xRoot3: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  nRoot: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(999, "الرقم كبير جدا"),
});
const initialValuesRoots = {
  xRoot1: 0,
  xRoot2: 0,
  xRoot3: 0,
  nRoot: 0,
};
const RootCalculator = () => {
  const [squareRoot, setSquareRoot] = useState(null);
  const [cubicRoot, setCubicRoot] = useState(null);
  const [nthRoot, setNthRoot] = useState(null);
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="row">
            <div>
              <p>
                تقدم حاسبة الجذور واجهة سهلة الاستخدام لحساب الجذور لأي رقم. يتيح استخدامها للمستخدمين فهم كيفية حساب الجذور، سواء كانت جذورًا تربيعية أو تكعيبية أو أي نوع آخر.
              </p>
              <h2 style={{ fontSize: "17px" }}>
                يتم حساب الجذور بالطريقة التالية
              </h2>
              <ul>
                <li>
                  قيمة ماتحت الجذر مرفوع الى قوة 1 تقسيم قيمة الجذر أي:
                </li>
                <li>
                  الناتج = قيمة ماتحت الجذر^(1/قيمة الجذر)
                  <br />y = x^(1/n)
                </li>
                <li>ملاحظة : لايوجد جذور للقيم السالبة</li>
              </ul>
              <b>
                يمكنك أيضا استخدم الحاسبة التالية لإيجاد قيمة الجذور :
              </b>
              <hr />
            </div>
          </div>
              <MobileUnderCalAds />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <div className="p-3 mb-2 bg-success text-white">
                <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
              </div>
              <hr />
              <Formik
                initialValues={initialValuesRoots}
                validationSchema={rootSchema}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  setFieldValue,
                  resetForm,
                  isValid,
                }) => (
                  <div dir="rtl">
                    <h3 style={{ fontSize: "16px" }} className="mb-3">حاسبة الجذر التربيعي</h3>
                    <div
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <TextField
                        label="xRoot"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.xRoot1}
                        name="xRoot1"
                        error={
                          Boolean(touched.xRoot1) &&
                          Boolean(errors.xRoot1)
                        }
                        helperText={touched.xRoot1 && errors.xRoot1}
                        sx={{
                          width: "160px",
                          ml: "2px",
                          bgcolor: "#f9f9f9",
                          "&  .MuiFormHelperText-root.Mui-error": {
                            backgroundColor:
                              "rgb(229, 230, 227) !important",
                            margin: 0,
                            padding: "8px 0 0 41px",
                          },
                        }}
                        size="small"
                        color="success"
                      />
                      <div style={{ fontSize: "25px" }}>√</div>
                      <Button
                        disabled={!isValid}
                        color="success"
                        sx={{
                          backgroundColor: "rgb(25,135,84)",
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                          color: "white",
                        }}
                        onClick={() => {
                          setSquareRoot(Math.sqrt(values.xRoot1));
                        }}
                      >
                        إحسب
                      </Button>
                      <Button
                        disabled={!isValid}
                        sx={{
                          backgroundColor: "rgb(108,117,125)",
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                          color: "white",
                        }}
                        onClick={() => {
                          setSquareRoot(null);
                          resetForm();
                        }}
                      >
                        امسح النتيجة
                      </Button>
                    </div>
                    <br />
                    {squareRoot && squareRoot > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          {` النتيجة : الجذر التربيعي ل ${values.xRoot1} هو : ${squareRoot}`}
                        </p>
                        <p className="p-3 mb-2 bg-info text-black">
                          {` طريقة الحل : ${values.xRoot1}^(1/2) = ${squareRoot}`}
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                    <hr />
                    <h3 style={{ fontSize: "16px" }} className="mb-3">حاسبة الجذر التكعيبي</h3>
                    <div
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <TextField
                        label="xRoot"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.xRoot2}
                        name="xRoot2"
                        error={
                          Boolean(touched.xRoot2) &&
                          Boolean(errors.xRoot2)
                        }
                        helperText={touched.xRoot2 && errors.xRoot2}
                        sx={{
                          width: "160px",
                          ml: "2px",
                          bgcolor: "#f9f9f9",
                          "&  .MuiFormHelperText-root.Mui-error": {
                            backgroundColor:
                              "rgb(229, 230, 227) !important",
                            margin: 0,
                            padding: "8px 0 0 41px",
                          },
                        }}
                        size="small"
                        color="success"
                      />
                      <div style={{ fontSize: "25px" }}>∛</div>
                      <Button
                        disabled={!isValid}
                        color="success"
                        sx={{
                          backgroundColor: "rgb(25,135,84)",
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                          color: "white",
                        }}
                        onClick={() => {
                          setCubicRoot(Math.cbrt(values.xRoot2));
                        }}
                      >
                        إحسب
                      </Button>
                      <Button
                        disabled={!isValid}
                        sx={{
                          backgroundColor: "rgb(108,117,125)",
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                          color: "white",
                        }}
                        onClick={() => {
                          setCubicRoot(null);
                          resetForm();
                        }}
                      >
                        امسح النتيجة
                      </Button>
                    </div>
                    <br />
                    {cubicRoot && cubicRoot > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          {` النتيجة : الجذر التكعيبي ل ${values.xRoot2} هو : ${cubicRoot}`}
                        </p>
                        <p className="p-3 mb-2 bg-info text-black">
                          {` طريقة الحل : ${values.xRoot2}^(1/3) = ${cubicRoot}`}
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                    <hr />
                    <h3 style={{ fontSize: "16px" }} className="mb-3">حاسبة الجذر لأي رقم تريده</h3>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <TextField
                        label="xRoot"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.xRoot3}
                        name="xRoot3"
                        error={
                          Boolean(touched.xRoot3) &&
                          Boolean(errors.xRoot3)
                        }
                        helperText={touched.xRoot3 && errors.xRoot3}
                        sx={{
                          width: "100px",
                          ml: "2px",
                          bgcolor: "#f9f9f9",
                          "&  .MuiFormHelperText-root.Mui-error": {
                            backgroundColor:
                              "rgb(229, 230, 227) !important",
                            margin: 0,
                            padding: "8px 0 0 41px",
                          },
                        }}
                        size="small"
                        color="success"
                      />
                      <div style={{ fontSize: "25px" }}>√</div>
                      <TextField
                        label="nRoot"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.nRoot}
                        name="nRoot"
                        error={
                          Boolean(touched.nRoot) && Boolean(errors.nRoot)
                        }
                        helperText={touched.nRoot && errors.nRoot}
                        sx={{
                          width: "60px",
                          ml: "2px",
                          mr: "2px",
                          transform: "translateY(-15px)",
                          bgcolor: "#f9f9f9",
                          "&  .MuiFormHelperText-root.Mui-error": {
                            backgroundColor:
                              "rgb(229, 230, 227) !important",
                            margin: 0,
                            padding: "8px 0 0 41px",
                          },
                        }}
                        size="small"
                        color="success"
                      />
                      <div className="my-3">
                        <Button
                          disabled={!isValid}
                          color="success"
                          sx={{
                            backgroundColor: "rgb(25,135,84)",
                            fontSize: "15px",
                            marginRight: "25px",
                            padding: "5px 25px",
                            color: "white",
                          }}
                          onClick={() => {
                            setNthRoot(
                              Math.pow(values.xRoot3, 1 / values.nRoot)
                            );
                          }}
                        >
                          إحسب
                        </Button>
                        <Button
                          disabled={!isValid}
                          sx={{
                            backgroundColor: "rgb(108,117,125)",
                            fontSize: "15px",
                            marginRight: "25px",
                            padding: "5px 25px",
                            color: "white",
                          }}
                          onClick={() => {
                            setNthRoot(null);
                            resetForm();
                          }}
                        >
                          امسح النتيجة
                        </Button>
                      </div>
                    </div>
                    {nthRoot && nthRoot > 0 && nthRoot !== Infinity ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          {` النتيجة : الجذر من الرتبة ${values.nRoot} للعدد ${values.xRoot3} هو : ${nthRoot}`}
                        </p>
                        <p className="p-3 mb-2 bg-info text-black">
                          {` طريقة الحل : ${values.xRoot3}^(1/${values.nRoot}) = ${nthRoot}`}
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                    <br />
                  </div>
                )}
              </Formik>
            </div>
          </div>
          <hr />
          <div className="row">
            <RelatedLinks />
            <hr />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList
          ></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: 'auto' }} >
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <u><h3 style={{ fontSize: '16px' }}>  حاسبة الجذر العام - حساب الجذر التربيعي والتكعيبي
                </h3>  </u>
              </div>
              <div className="info-section-body">
                <p>
                  في علم الرياضيات، يُعرَف الجذر العام عن العدد الصحيح (س) برقم آخر يُعبِّر عنه بالحرف (ب)، بحيث يكون ناتج تكرار ضرب هذا الرقم في نفسه n مرة يساوي (س). يُعبَّر عن ذلك في المعادلة:
                </p>
                <p>
                  <math display="block">
                    <msup>
                      <mroot>
                        <mrow>
                          <mi>a</mi>
                        </mrow>
                        <mn>n</mn>
                      </mroot>
                      <mo>=</mo>
                      <mi>b</mi>
                    </msup>
                  </math>
                </p>
                <p>
                  <math display="block">
                    <msup>
                      <mi>b</mi>
                      <mn>n</mn>
                    </msup>
                    <mo>=</mo>
                    <mi>a</mi>
                  </math>
                </p>
                <h4>تقدير الجذر</h4>
                <p>
                  تشمل بعض الجذور الشائعة الجذر التربيعي (n=2) والجذر التكعيبي (n=3). حساب الجذور التربيعية والجذور النا يتطلب تقديرًا وتجريبًا.
                </p>
                <p>
                  لحساب √س:
                </p>
                <ol>
                  <li>قدّر رقمًا باسم (ب)</li>
                  <li>قسّم (س) على (ب). إذا كان الرقم الناتج (ج) دقيقًا حتى الرقم العشري المطلوب، توقف.</li>
                  <li>قم بحساب المتوسط بين (ب) و(ج) واستخدم النتيجة كتخمين جديد</li>
                  <li>كرّر الخطوة الثانية</li>
                </ol>
                <h4>مثال:</h4>
                <p>
                  العثور على <strong>³√125</strong> بتقريبه إلى 3 أماكن عشرية:
                </p>
                <p>
                  <strong>التخمين: 5.432</strong>
                  <br />
                  125 ÷ 5.432³ = 5.452
                  <br />
                  (5.432 × 3 + 5.452) / 4 = 5.447
                  <br />
                  125 ÷ 5.447³ = 5.445
                  <br />
                  (5.445 × 3 + 5.447) / 4 = 5.446
                </p>
                <p>
                  يمكن الاستنتاج من هذا أن المتابعة في الحساب ستؤدي إلى رقم يُقرب إلى 5.446، مما يجعله التقدير النهائي إلى 3 أماكن عشرية.
                </p>
                <h4>الجذر التربيعي</h4>
                <p>
                  الجذر التربيعي في الرياضيات هو العدد الحقيقي الإيجابي (ص) الذي إذا تم ضربه في نفسه، سيكون الناتج هو العدد (س). كمثال، جذر العدد 16 هو العدد 4، حيث أن ضرب العدد 4 في نفسه يعطي الناتج 16. في الرياضيات، يُستخدم رمز √ لتمثيل الجذر التربيعي، وبالتالي يمكن قراءة التعبير السابق كـ "جذر العدد 16 يساوي 4".
                </p>
                <h4>مثال:</h4>
                <p>
                  لنحسب جذر العدد 49. باستخدام علامة الجذر التربيعي √، يكون الحساب كالتالي:
                </p>
                <code>
                  √49 = 7
                </code>
                <p>
                  هنا، جذر العدد 49 هو 7، حيث أن ضرب العدد 7 في نفسه يساوي 49.
                </p>
                <h4>الجذر التكعيبي</h4>
                <p>
                  يُعرف الجذر التكعيبي بأنه العدد الذي إذا تم ضربه في نفسه مرتين سيساوي العدد (س). الجذر التكعيبي يُعبَّر عنه باستخدام الرمز <strong>³√</strong>، وهو يمثل الجذر الثالث للعدد. مثال على الجذر التكعيبي هو <strong>³√27 = 3</strong>؛ حيث أن 3 مرفوعة إلى التكعيب مرتين تساوي 27.
                </p>
                <p>
                  <strong>برنامج حساب الجذر التربيعي والتكعيبي</strong>
                </p>
                <p>
                  كثير منا قد لا يعرف كيفية حساب الجذر التربيعي والتكعيبي باستخدام الآلة الحاسبة لأي عدد أو قد يفتقر إلى وجود آلة حاسبة بها وظيفة الجذر. لحسن الحظ، قمنا بتطوير برنامج بسيط يقوم بهذه العمليتين في أقل من ثانية. كل ما عليك هو إدخال الرقم في الخانة المخصصة ومن ثم النقر على زر "احسب" للحصول على قيمة الجذر التربيعي أو التكعيبي وعرضها أمامك على الشاشة.
                </p>
                <p>
                  <strong>ملاحظة:</strong> يمكن تغيير الأمثلة والتفاصيل لتناسب سياق التطبيق أو الموقع.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default RootCalculator;
